// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ordinateurs */
@media only screen and (min-width: 1200px) {
  .first-column {
    width: 30.7%;
  }
  .second-column {
    width: 26.2%;
  }
  .third-column {
    width: 27.7%;
  }
  .width-quantity {
    width: 22.8%;
  }
  .width-img {
    width: 31.4%;
  }
  .aug-table td #margin_button {
    padding-right: 20px !important;
  }
  .aug-table td {
    padding: 0px 10px !important;
  }
  .aug-table #margin_button {
    padding: 0px 20px !important;
  }
}
@media only screen and (min-width: 1440px) {
  .first-column {
    width: 29.6%;
  }
  .second-column {
    width: 26.1%;
  }
  .third-column {
    width: 27.3%;
  }
  .width-quantity {
    width: 24%;
  }
  .width-img {
    width: 28%;
  }
  .aug-table td {
    padding: 0px 10px !important;
  }
  .aug-table #margin_button {
    padding: 0px 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/customstyle.scss"],"names":[],"mappings":"AAAA,gBAAA;AAEA;EAEG;IACC,YAAA;EADF;EAIF;IACK,YAAA;EAFH;EAKF;IACI,YAAA;EAHF;EAOF;IACI,YAAA;EALF;EAQE;IACI,YAAA;EANN;EAQE;IACI,8BAAA;EANN;EASM;IACI,4BAAA;EAPV;EAQO;IACG,4BAAA;EANV;AACF;AASA;EAGO;IACC,YAAA;EATN;EAWE;IACI,YAAA;EATN;EAYE;IACI,YAAA;EAVN;EAaE;IACI,UAAA;EAXN;EAeM;IACA,UAAA;EAbN;EAgBU;IACI,4BAAA;EAdd;EAeW;IACG,4BAAA;EAbd;AACF","sourcesContent":["/* ordinateurs */\n\n@media only screen and (min-width: 1200px) {\n   // --screen medium\n   .first-column {\n    width: 30.7% ;\n\n}\n.second-column{\n     width: 26.2% ;\n\n}\n.third-column{\n    width: 27.7% ;\n\n}\n\n.width-quantity{\n    width: 22.8%;\n    \n    }   \n    .width-img{\n        width: 31.4%;\n    }\n    .aug-table td #margin_button {\n        padding-right:  20px !important;\n    }\n    .aug-table{\n        td {\n            padding: 0px 10px !important;\n        }#margin_button {\n            padding: 0px 20px !important;\n        }\n    }\n}\n@media only screen and (min-width: 1440px) {\n\n       // --screen trés large\n       .first-column {\n        width: 29.6% ;\n    }\n    .second-column{\n        width: 26.1% ;\n\n    }\n    .third-column{\n        width: 27.3% ;\n    }\n\n    .width-quantity{\n        width: 24%;\n        \n        }\n\n        .width-img{\n        width: 28%;\n        }\n        .aug-table{\n            td {\n                padding: 0px 10px !important;\n            }#margin_button {\n                padding: 0px 20px !important;\n            }\n        }        \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
